import { ref, onMounted, onUnmounted } from 'vue';

/**
 * Composable to detect device orientation changes.
 * Returns whether the device is in landscape mode on mobile devices.
 * Used to show rotation warnings during video calls.
 */
export function useDeviceOrientation() {
  const isLandscape = ref(false);
  const isMobile = ref(false);

  function checkOrientation() {
    // Use matchMedia for reliable cross-browser detection
    const landscapeQuery = window.matchMedia('(orientation: landscape)');
    // Only consider it landscape on mobile devices (screens <= 1024px wide in landscape)
    const mobileQuery = window.matchMedia('(max-width: 1024px)');

    isMobile.value = mobileQuery.matches;
    isLandscape.value = landscapeQuery.matches && mobileQuery.matches;
  }

  function handleOrientationChange() {
    checkOrientation();
  }

  onMounted(() => {
    checkOrientation();

    // Listen for orientation changes via resize
    window.addEventListener('resize', handleOrientationChange);

    // Also use screen.orientation API if available (better for mobile)
    if (screen.orientation) {
      screen.orientation.addEventListener('change', handleOrientationChange);
    }
  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleOrientationChange);

    if (screen.orientation) {
      screen.orientation.removeEventListener('change', handleOrientationChange);
    }
  });

  return {
    isLandscape,
    isMobile
  };
}
